import { chatPublicShareQueryKey } from "@frontend-shared/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

export const useRevokeChatPublicShare = (chatUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => chatApi.revokeChatPublicShare(chatUuid),
    onSuccess: () => {
      // NOTE: Revoking leaves the chat with no live link, which is exactly what
      // the endpoint returns — set it directly rather than invalidating, so the
      // section flips to its empty state without a refetch round-trip.
      queryClient.setQueryData(chatPublicShareQueryKey(chatUuid), null);
    },
    meta: { suppressErrorToast: true },
  });
};
